import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Drawer, IconButton, InputAdornment, Modal, TextField, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toggleLoader } from "../../Store/loader/loaderReducer";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import JoditEditor, { Jodit } from 'jodit-react';
import { getPathFromLocalStroage } from "../../utils";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import './Editor.css';
import styles from "./Editor.module.css";

import moment from "moment";
import axios from "axios";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SyncIcon from '@mui/icons-material/Sync';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import ScheduleModal from "../Modal/ScheduleModal/ScheduleModal";
import ConfirmationModal from "../Modal/ConfirmationModal/ConfirmationModal";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ReviewsIcon from '@mui/icons-material/Reviews';
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";
import CommonToolTip from "../../Utils/CommonToolTip";

export const allowedFileTypes = ['jpg', 'jpeg', 'png', 'gif', 'jfif', 'pjpeg', 'pjp', 'svg', 'bmp', 'tif', 'tiff', 'webp', 'ico', 'jp2', 'heic', 'heif', 'wbmp'];
const platform = 'No platform connected. Go to the Integration tab to connect your platform.'

const Editor = () => {
  const editorRef = useRef(null);
  const joditWrapperRef = useRef(null);
  const textAreaRef = useRef(null);
  const savedRangeRef = useRef(null);
  const shouldHighlightRef = useRef(false);
  const { id } = useParams();

  const toolbarContainerRef = useRef(null);
  const cropperRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const scheduleValues = location?.state?.item;
  const org_info = useSelector((state) => state?.org_info?.value);
  const org_id = org_info?.default_organizations?.Id;

  const dispatch = useDispatch();
  const [tabvalue, setTabvalue] = useState(null);
  const [schedule, setSchedule] = useState({ title: "", keyword: [], date: "", content: "", id: "", scheduled_time: "" });
  const [open, setOpen] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [type, setType] = useState('');
  const [drawer, setDrawer] = useState(false);
  const [excerpt, setExcerpt] = useState('');
  const [image, setImage] = useState(null);
  const [toggleImage, setToggleImage] = useState(false);
  const [fileId, setFileId] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [openAI, setOpenAI] = useState(false);
  const [rephrasedWord, setRephrasedWord] = useState([]);
  const [prompt, setPrompt] = useState('');
  const [selectedWord, setSelectedWord] = useState('');
  const [loading, setLoading] = useState(false);
  const [isPaste, setIsPaste] = useState(true);
  const [isUndo, setIsUndo] = useState(false);
  const [copyItem, setCopyItem] = useState('');
  const [copy, setCopy] = useState(false);
  const [postSetting, setPostSetting] = useState(null);

  const redioBtn = [0, 1];
  const maxChars = 200;
  const pathLocal = getPathFromLocalStroage();

  const setEditorRef = (instance) => {
    if (instance) {
      editorRef.current = instance;
    }
  };


  useEffect(() => {
    handleDrafts()
  }, [location])

  const handleDrafts = () => {
    let data = {
      post_id: id,
      org_id: org_id,
    };

    dispatch(toggleLoader(true));
    axios
      .get(process.env.REACT_APP_POST, {
        params: data,
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        const response = res.data.data[0];
        setSchedule({ title: response.Title, keyword: response.Keywords, date: response.Scheduled_Time, content: response?.Content, id: response.Id, scheduled_time: response?.Scheduled_Time, status: response?.Status })
        setTabvalue(response.Status);
        setFileId(response?.File_Id);
        setExcerpt(response?.Excerpt);
        setPostSetting({ fileId: response?.File_Id, excerpt: response?.Excerpt });
        dispatch(toggleLoader(false));
      })
      .catch((err) => {
        toast.error(err.response.data.error.message || "An unexpected error occurred. Please try again later.");
        navigate(`/c${org_id}${pathLocal.path}`);
        dispatch(toggleLoader(false));
      });
  };

  useEffect(() => {
    const handleResize = () => {
      const titleTextarea = document.querySelector('.jodit-toolbar__box');
      const compStyles = window.getComputedStyle(titleTextarea);
      document.documentElement.style.setProperty('--custom_textarea_margin_top', compStyles.height)

    }
    handleResize();
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (toolbarContainerRef.current) {
      config.toolbarContainer = toolbarContainerRef.current;
    }
  }, []);

  useEffect(() => {
    if (type && type !== 'Trash') {
      postOptions();
    }
  }, [type]);

  function getTextContentHeight(textarea) {
    const originalHeight = textarea.style.height;
    textarea.style.height = 'auto';
    textarea.scrollTop = 10000;
    const contentHeight = textarea.scrollHeight;
    textarea.scrollTop = 0;
    return contentHeight;
  }



  const handleChange = (event) => {


    const inputText = event.target.value;
    const isDeleting = inputText.length < schedule.title.length
    const contentHeight = getTextContentHeight(textAreaRef.current) + (isDeleting ? 0 : 0);
    textAreaRef.current.style.height = contentHeight + 'px'
    document.documentElement.style.setProperty('--toolbar__box_margin_bottom', contentHeight + 'px')


    if (inputText.length <= maxChars) {
      setSchedule({ ...schedule, title: inputText })

    } else {
      // Optionally, show a message to the user
      // alert(`You can only enter up to ${maxChars} words.`);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  const config = useMemo(
    () => ({
      // iframe: true,
      editHTMLDocumentMode: true,
      // "enter": "BR",
      "readonly": false,
      'enableDragAndDropFileToEditor': true,
      "showCharsCounter": false,
      "defaultActionOnPaste": "insert_clear_html",
      "showWordsCounter": false,
      "showXPathInStatusbar": false,
      "disablePlugins": ['add-new-line', 'placeholder'],
      'autoresize': false,
      "allowResizeY": false,
      "allowSelectOutOfEditor": true,
      "resizable": false,
      "imageResize": false,


      uploader: {
        insertImageAsBase64URI: true,
        imagesExtensions: ['jpg', 'png', 'jpeg', 'gif', 'svg', 'webp'],
        isSuccess: function (resp) {
          return !resp.error;
        },
        getMessage: function (resp) {
          return resp.msgs.join("\n");
        },
        process: function (resp) {
          return resp;
        },

      },
      buttons: [
        'bold', 'italic', 'underline', 'strikethrough', 'eraser',
        '|',
        'ul', 'ol',
        '|',
        'font', 'fontsize', 'paragraph', 'lineHeight',
        '|',
        'indent', 'outdent',
        '|',
        'left', 'center', 'right', 'justify',
        '|',
        'undo', 'redo',
        '|',
        'link', 'unlink',
        '|',
        'image',
        '|',
        'fullsize'
      ],

      controls: {
        font: {
          list: Jodit.atom({
            'Inter': 'Default',
            'Arial': 'Arial',
            'Calibri': 'Calibri',
            'Times New Roman': 'Times New Roman',
            'Open Sans': 'Open Sans',
            'Verdana': 'Verdana'
          })
        },
        link: {
          openInNewTabCheckbox: true,
          openInNewTabCheckboxByDefault: true,
          exec: (editor, current, control, btn) => {
            editor.s.insertHTML(`<a href="${current || ''}" target="_blank" rel="noopener noreferrer">${editor.s.html}</a>`);
          }
        }
      },

      defaultStyle: 'font-family: Inter, sans-serif; font-size: 14px;',
      style: {
        fontFamily: 'Inter',
      },
      events: {

        afterInit: (editor) => {
          const saveSelection = () => {
            const nativeSel = editor.s.sel;

            if (!nativeSel || nativeSel.rangeCount === 0) {
              return;
            }

            const range = nativeSel.getRangeAt(0);
            if (!range.collapsed) {
              savedRangeRef.current = range.cloneRange();
              shouldHighlightRef.current = true;
            }
          };

          const removeBackgrounds = () => {
            setSelectedWord('');
            const editorBody = editor.editor;
            if (!editorBody) return;

            const spans = editorBody.querySelectorAll('span[style*="background-color"]');

            spans.forEach((span) => {
              const parent = span.parentNode;
              if (!parent) return;

              while (span.firstChild) {
                parent.insertBefore(span.firstChild, span);
              }
              parent.removeChild(span);
            });
          };

          const handleBlur = () => {
            if (!shouldHighlightRef.current) {
              console.log('No highlight action needed.');
              return;
            }

            const savedRange = savedRangeRef.current;

            if (!savedRange) {
              console.log('Nothing saved to apply background.');
              return;
            }

            setTimeout(() => {
              highlightSelection(savedRange);
              document.getSelection().removeAllRanges();
            }, 100);

            savedRangeRef.current = null;
            shouldHighlightRef.current = false;
          };

          const handleSetMarker = () => {
            const sel = editor.selection;
            if (!sel || !sel.sel || !sel.sel.rangeCount) return;

            const range = sel.sel.getRangeAt(0).cloneRange();
            range.collapse(true);

            const marker = document.createElement('span');
            marker.className = 'jodit-cursor-marker';
            marker.innerHTML = '<span style="border-left: 2px solid #333; margin-left: -1px;"></span>';
            marker.setAttribute('contenteditable', 'false');

            range.insertNode(marker);
            editor.__cursorMarker = marker;
          }

          const highlightSelection = (range) => {
            const nodes = getTextNodesInRange(range);
            nodes.forEach((node) => {
              const span = editor.createInside.element('span');
              span.style.backgroundColor = '#D3D3D3';

              const nodeClone = node.cloneNode(true);
              const splitedSelection = selectedRef.current.split('\n');

              if (nodeClone.textContent.trim() !== selectedRef.current.trim() && !splitedSelection.includes(nodeClone.textContent.trim())) return;
              span.appendChild(nodeClone);
              node.parentNode.replaceChild(span, node);
            });
          };

          const getTextNodesInRange = (range) => {
            const textNodes = [];
            const treeWalker = document.createTreeWalker(
              range.commonAncestorContainer,
              NodeFilter.SHOW_TEXT,
              {
                acceptNode: (node) => {
                  const nodeRange = document.createRange();
                  nodeRange.selectNodeContents(node);

                  return range.intersectsNode(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
                },
              },
            );

            while (treeWalker.nextNode()) {
              textNodes.push(treeWalker.currentNode);
            }

            return textNodes;
          };


          editor.events.on('mouseup', saveSelection);
          editor.events.on('keyup', saveSelection);

          editor.events.on('blur', () => {
            handleBlur();
            handleSetMarker();
          });

          editor.events.on('focus', () => {

            if (editor.__cursorMarker) {
              setTimeout(() => {
                editor.__cursorMarker?.remove();
                delete editor.__cursorMarker;

                editor.selection.restore();
              }, 0);
            }
            if (!shouldHighlightRef.current) {
              removeBackgrounds();
            }
          });

          editor.events.on('beforeCommand', (command, value) => {
            if (command === 'insertLink' && typeof value === 'string') {
              const parser = new DOMParser();
              const doc = parser.parseFromString(value, 'text/html');
              const link = doc.querySelector('a[href]');
              if (link) {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
                return link.outerHTML;
              }
            }
          });

          editor.events.on('change', () => {
            const links = editor.editor.querySelectorAll('a[href]');
            links.forEach(link => {
              if (!link.hasAttribute('target')) {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
              }
            });
          });

          editor.events.on('afterOpenPopup', (popup) => {
            const container = popup.container;
            if (!container) return;
            const openInNewTabCheckbox = container.querySelector('input[type="checkbox"][name="target"]');
            if (openInNewTabCheckbox) {
              openInNewTabCheckbox.checked = true;
            }
          });
        },
      },
    }), []);

  const configtwo = useMemo(
    () => ({
      // "enter": "BR",
      "readonly": true,
      'enableDragAndDropFileToEditor': true,
      "showCharsCounter": false,
      "defaultActionOnPaste": "insert_clear_html",
      "showWordsCounter": false,
      "showXPathInStatusbar": false,
      'disablePlugins': 'add-new-line',
      'autoresize': false,
      "allowResizeY": false,
      "disablePlugins": "placeholder",
      "allowSelectOutOfEditor": true,


      uploader: {
        insertImageAsBase64URI: true,
        imagesExtensions: ['jpg', 'png', 'jpeg', 'gif', 'svg', 'webp'],
        isSuccess: function (resp) {
          return !resp.error;
        },
        getMessage: function (resp) {
          return resp.msgs.join("\n");
        },
        process: function (resp) {
          return resp;
        },

      },
      buttons: [
        'bold', 'italic', 'underline', 'strikethrough', 'eraser',
        '|',
        'ul', 'ol',
        '|',
        'font', 'fontsize', 'paragraph', 'lineHeight',
        '|',
        'indent', 'outdent',
        '|',
        'left', 'center', 'right', 'justify',
        '|',
        'undo', 'redo',
        '|',
        'link', 'unlink',
        '|',
        'image',
        '|',
        'fullsize'
      ],

      controls: {
        font: {
          list: Jodit.atom({
            'Inte': 'Default',
            'Arial': 'Arial',
            'Calibri': 'Calibri',
            'Times New Roman': 'Times New Roman',
            'Open Sans': 'Open Sans',
            'Verdana': 'Verdana'
          })
        }
      },

      defaultStyle: 'font-family: Inter, sans-serif; font-size: 14px;',
      style: {
        fontFamily: 'Inter',
      },
      events: {
        afterInit: (editor) => {
          const saveSelection = () => {
            const sel = editor.selection;
            const range = sel?.sel?.getRangeAt(0);

            if (range && !range.collapsed) {
              savedRangeRef.current = range.cloneRange();
              shouldHighlightRef.current = true;
            }
          };

          const removeBackgrounds = () => {
            const editorBody = editor.editor;
            if (!editorBody) return;

            const spans = editorBody.querySelectorAll('span[style*="background-color"]');

            spans.forEach((span) => {
              const parent = span.parentNode;
              if (!parent) return;

              while (span.firstChild) {
                parent.insertBefore(span.firstChild, span);
              }
              parent.removeChild(span);
              setSelectedWord('');
            });
          };

          const handleBlur = () => {
            if (!shouldHighlightRef.current) {
              console.log('No highlight action needed.');
              return;
            }

            const savedRange = savedRangeRef.current;

            if (!savedRange) {
              console.log('Nothing saved to apply background.');
              return;
            }

            setTimeout(() => {
              highlightSelection(savedRange);
              document.getSelection().removeAllRanges();
            }, 100);

            savedRangeRef.current = null;
            shouldHighlightRef.current = false;
          };

          const highlightSelection = (range) => {
            const nodes = getTextNodesInRange(range);
            nodes.forEach((node) => {
              const span = editor.createInside.element('span');
              span.style.backgroundColor = '#D3D3D3';

              const nodeClone = node.cloneNode(true);
              const splitedSelection = selectedRef.current.split('\n');

              if (nodeClone.textContent.trim() !== selectedRef.current.trim() && !splitedSelection.includes(nodeClone.textContent.trim())) return;
              span.appendChild(nodeClone);
              node.parentNode.replaceChild(span, node);
            });
          };

          const getTextNodesInRange = (range) => {
            const textNodes = [];
            const treeWalker = document.createTreeWalker(
              range.commonAncestorContainer,
              NodeFilter.SHOW_TEXT,
              {
                acceptNode: (node) => {
                  const nodeRange = document.createRange();
                  nodeRange.selectNodeContents(node);

                  return range.intersectsNode(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
                },
              },
            );

            while (treeWalker.nextNode()) {
              textNodes.push(treeWalker.currentNode);
            }

            return textNodes;
          };

          editor.events.on('mouseup', saveSelection);
          editor.events.on('keyup', saveSelection);

          editor.events.on('blur', () => {
            handleBlur();
          });

          editor.events.on('focus', () => {
            if (!shouldHighlightRef.current) {
              removeBackgrounds();
            }
          });
        },
      },
    }), []);

  useEffect(() => {
    const preventDeselect = (event) => {
      if (editorRef.current && editorRef.current?.editor?.container) {
        if (!editorRef.current.editor.container.contains(event.target)) {
          event.preventDefault();
        }
      }
    };

    document.addEventListener("mousedown", preventDeselect);
    return () => {
      document.removeEventListener("mousedown", preventDeselect);
    };
  }, []);

  const insertBase64Image = () => {
    const base64Image = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAA...'; // Add your full base64 string here
    // Ensure the editor is initialized
    if (editorRef.current && editorRef.current.editor) {
      editorRef.current.editor.selection.insertHTML(`<img src="${base64Image}" alt="Base64 Image" />`);
    } else {
      console.error('Editor not initialized');
    }
  };

  const cleanJoditMarkers = (html) => {
    return html.replace(/<span class="jodit-cursor-marker"[^>]*>[\s\S]*?<\/span>/g, '');
  }


  const handleSaveDraft = () => {



    const cleanContent = cleanJoditMarkers(schedule.content);

    let data = {
      title: schedule.title,
      keywords: schedule.keyword,
      scheduled_date: moment(schedule?.date, "DD/MM/YYYY hh:mm A").format("DD-MMM-YYYY hh:mm"),
      content: cleanContent,
      org_id: org_info?.default_organizations?.Id,
      id: schedule.id,
      excerpt: excerpt,
      file_id: fileId,
    };

    if (excerpt === postSetting?.excerpt) delete data.excerpt;
    if (fileId === postSetting?.fileId) delete data.file_id;

    if (tabvalue === 2) {
      delete data.scheduled_date;
    }

    console.log('data', data);


    setLoading(true);
    dispatch(toggleLoader(true));
    axios
      .put(process.env.REACT_APP_POST, data, {
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        console.log('res', res);

        dispatch(toggleLoader(false));
        toast.success('Saved');
        setLoading(false);
        // navigate(`/c${org_id}${pathLocal.path}`);
      })
      .catch((err) => {
        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
        setLoading(false);
      });
  };

  const handleApprove = () => {

    const cleanContent = cleanJoditMarkers(schedule.content);

    let data = {
      title: schedule.title,
      org_id: org_info?.default_organizations?.Id,
      post_id: schedule.id,
      content: cleanContent,
      excerpt: excerpt,
      file_id: fileId
    };

    if (excerpt === postSetting?.excerpt) delete data.excerpt;
    if (fileId === postSetting?.fileId) delete data.file_id;

    setLoading(true);
    dispatch(toggleLoader(true));
    axios
      .post(process.env.REACT_APP_PUBLISH, data, {
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        setLoading(false);
        dispatch(toggleLoader(false));
        localStorage.setItem(
          "path",
          JSON.stringify({ path: "/post/published", value: 2 })
        );
        navigate(`/c${org_id}${pathLocal.path}`);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.error?.details || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
      });
  };

  const postOptions = () => {
    let data = {
      ids: [schedule.id],
      limit: 100,
      cursor: 1,
      org_id: org_info?.default_organizations?.Id,
    };
    dispatch(toggleLoader(true));
    const API =
      type === "Trash"
        ? process.env.REACT_APP_POST
        : type === "Delete"
          ? process.env.REACT_APP_TRASH :
          type === "Revert" ?
            process.env.REACT_APP_REVERTDRAFT :
            process.env.REACT_APP_RESTORE
    if (type === "Restore") {
      axios
        .post(API, data, { withCredentials: process.env.REACT_APP_CREDENTIALS })
        .then((res) => {
          dispatch(toggleLoader(false));
          localStorage.setItem(
            "path",
            JSON.stringify({ path: "/post/drafts", value: 0 })
          );
          navigate(`/c${org_id}${pathLocal.path}`);
          toast.success(
            type === "Restore" && "Post restored and moved to drafts."
          );
        })
        .catch((err) => {
          const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
          const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
          toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
          dispatch(toggleLoader(false));
          navigate(`/c${org_id}${pathLocal.path}`);
        });
    }
    else if (type === "Revert") {
      axios
        .post(API, data, { withCredentials: process.env.REACT_APP_CREDENTIALS })
        .then((res) => {
          dispatch(toggleLoader(false));
          localStorage.setItem(
            "path",
            JSON.stringify({ path: "/post/drafts", value: 0 })
          );
          navigate(`/c${org_id}${pathLocal.path}`);
          // toast.success(
          //   postType === "Restore" && "Post restored and moved to drafts."
          // );
        })

        .catch((err) => {
          const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
          const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
          toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
          dispatch(toggleLoader(false));
        });
    }


    else {
      axios
        .delete(API, {
          data: data,
          withCredentials: process.env.REACT_APP_CREDENTIALS,
        })
        .then((res) => {
          dispatch(toggleLoader(false));
          setConfirmation(false)
          navigate(`/c${org_id}${pathLocal.path}`);
          // {
          //   type === "Trash" && localStorage.setItem(
          //     "path",
          //     JSON.stringify({ path: "/post/trash", value: 5 })
          //   );
          // }
          toast.success(
            type === "Trash" ? "Post moved to trash." : "Post deleted."
          );
        })
        .catch((err) => {
          const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
          const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
          toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
          dispatch(toggleLoader(false));
          navigate(`/c${org_id}${pathLocal.path}`);
          setConfirmation(false)
        });
    }

  };

  const handleDraft = () => {
    let data = {
      id: schedule.id,
      title: schedule.title,
      keywords: schedule.keyword,
      scheduled_date: moment(schedule?.date, "DD/MM/YYYY hh:mm A").format("DD-MMM-YYYY hh:mm"),
      content: schedule.content,
      org_id: org_info?.default_organizations?.Id,
      excerpt: excerpt
    };
    if (data.scheduled_date === 'Invalid date') {
      delete data.scheduled_date;
    }

    dispatch(toggleLoader(true));
    axios
      .post(process.env.REACT_APP_POST, data, {
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        dispatch(toggleLoader(false));
        navigate(`/c${org_id}${pathLocal.path}`);
      })
      .catch((err) => {
        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        navigate(`/c${org_id}${pathLocal.path}`);
        dispatch(toggleLoader(false));
      });
  };


  const handleSentForReview = (item) => {

    let data = {
      org_id: org_info?.default_organizations?.Id,
      post_id: schedule.id,
    };

    dispatch(toggleLoader(true));
    axios
      .post(process.env.REACT_APP_SEND_FOR_REVIEW, data, {
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        dispatch(toggleLoader(false));
        navigate(`/c${org_id}${pathLocal.path}`);
        localStorage.setItem(
          "path",
          JSON.stringify({ path: "/post/pending-review", value: 4 })
        );
        // changeTabValue(3);
      })
      .catch((err) => {
        // console.log('err', err.response.data.error.details);
        toast.error(err?.response?.data?.error?.details || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
      });
  };


  const getTooltipTitle = (item) => {
    return (
      <Box className={styles.table_moreinfo_popper}>

        {/* <Button
          startIcon={<SyncIcon />}
          variant="text"
          onClick={() => handleSaveDraft()}
        >
          Save as draft
        </Button> */}
        {tabvalue !== 2 && <Button
          startIcon={<ScheduleSendIcon />}
          variant="text"
          onClick={() => { org_info.blog_platform.length > 0 ? setOpen(true) : toast.error(platform) }}
        >
          Schedule post
        </Button>}
        {tabvalue === 2 && <Button
          startIcon={<SyncIcon />}
          variant="text"
          onClick={() => { setType("Revert") }}
        >
          Revert to Draft
        </Button>}
        <Button
          startIcon={<ContentCopyIcon />}
          variant="text"
          onClick={() => handleDraft()}
        >
          Duplicate draft
        </Button>
        <Button
          startIcon={<DeleteOutlineIcon />}
          className={styles.table_trash_btns_delete}
          variant="text"
          onClick={() => { setType("Trash"); setConfirmation(true) }}
        >
          Move to trash
        </Button>
        {redioBtn.includes(tabvalue) && <Button
          startIcon={<ReviewsIcon />}
          // className={styles.table_trash_btns_delete}
          variant="text"
          onClick={() => { org_info.blog_platform.length > 0 ? handleSentForReview() : toast.error(platform) }}
        >
          Send for review
        </Button>}
        {/* <Button
          startIcon={<DeleteOutlineIcon />}
          className={styles.table_trash_btns_delete}
          variant="text"
          onClick={() => {setType("Delete");setConfirmation(true)}}
        >
          Delete
        </Button> */}
      </Box>
    );
  };


  const handleSchedule = (date) => {

    let data = {
      org_id: org_info?.default_organizations?.Id,
      post_id: schedule.id,
      scheduled_date: moment(date, "DD-MMM-YYYY hh:mm a").format("DD-MMM-YYYY HH:mm"),
    };



    dispatch(toggleLoader(true));
    if (tabvalue === 0) {
      axios.post(process.env.REACT_APP_SCHEDULE, data, { withCredentials: process.env.REACT_APP_CREDENTIALS })
        .then((res) => {
          dispatch(toggleLoader(false));
          localStorage.setItem(
            "path",
            JSON.stringify({ path: "/post/scheduled", value: 1 })
          );
          navigate(`/c${org_id}${pathLocal.path}`);
          setOpen(false);
        })
        .catch((err) => {
          const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
          const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
          toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
          dispatch(toggleLoader(false));
          setOpen(false)
        });
    } else {
      axios.put(process.env.REACT_APP_SCHEDULE, data, { withCredentials: process.env.REACT_APP_CREDENTIALS })
        .then((res) => {
          dispatch(toggleLoader(false));
          localStorage.setItem(
            "path",
            JSON.stringify({ path: "/post/scheduled", value: 1 })
          );
          navigate(`/c${org_id}${pathLocal.path}`);
          setOpen(false);
        })
        .catch((err) => {
          const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
          const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
          toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
          dispatch(toggleLoader(false));
          setOpen(false)
        });
    }
  };


  const handleRejectandDraft = () => {
    let data = {
      org_id: org_info?.default_organizations?.Id,
      post_id: schedule.id,
    };

    dispatch(toggleLoader(true));
    axios
      .post(process.env.REACT_APP_REJECT, data, {
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        dispatch(toggleLoader(false));
        toast.success('Successfully Rejected');
        localStorage.setItem(
          "path",
          JSON.stringify({ path: "/post/drafts", value: 0 })
        );
        navigate(`/c${org_id}${pathLocal.path}`);

      })
      .catch((err) => {
        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
      });
  };

  const handleCancelSchedule = () => {
    const data = {
      org_id: org_info?.default_organizations?.Id,
      post_id: schedule.id,
    }
    axios
      .delete(process.env.REACT_APP_SCHEDULE, {
        data: data,
        withCredentials: process.env.REACT_APP_CREDENTIALS,
      })
      .then((res) => {
        dispatch(toggleLoader(false));
        toast.success('Success');
        navigate(`/c${org_id}${pathLocal.path}`);

      })
      .catch((err) => {
        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        dispatch(toggleLoader(false));
      });
  };

  const handleEditorChange = (newContent) => {

    const cleanContent = cleanJoditMarkers(newContent);
    setSchedule({ ...schedule, content: cleanContent });
  };

  const handleUpload = (e) => {
    const url = URL.createObjectURL(e);
    const fileExtension = e?.name?.split(".")?.at(-1);
    if (!allowedFileTypes.includes(fileExtension)) {
      toast.error('Only image format is accepted');
    } else {
      setImage(url);
      setToggleImage(true);
    }
  };

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
  }));

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const handleDelete = () => {
    const data = {
      org_id: org_info?.default_organizations?.Id,
      file_id: fileId,
      post_id: id
    }
    dispatch(toggleLoader(true));
    axios.delete(process.env.REACT_APP_FEATURED_IMAGE, { withCredentials: process.env.REACT_APP_CREDENTIALS, data: data })
      .then((res) => {
        setToggleImage(false);
        setImage(null);
        setFileId(null);
        dispatch(toggleLoader(false));
      })
      .catch((err) => {
        dispatch(toggleLoader(false));
        const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
      });
  };

  const handleRephrase = (key, i) => {
    dispatch(toggleLoader(true));
    if (key === 'retry') setLoading(true);
    let data = { org_id: org_info?.default_organizations?.Id, text: key ? rephrasedWord[i]?.selectedWord : selectedWord, prompt: prompt ? prompt : 'Can you change the paragraph more clearer?' }
    axios.post(process.env.REACT_APP_REPHRASE, data, { withCredentials: process.env.REACT_APP_CREDENTIALS })
      .then((res) => {
        setPrompt('');
        if (key !== 'retry') {
          let data = [...rephrasedWord];
          data[data?.length - 1]['changed'] = res?.data?.changed;
          data[data?.length - 1]['text'] = res?.data?.response;
          data[data?.length - 1]['prompt'] = prompt ? prompt : 'Can you change the paragraph more clearer?';
          setRephrasedWord(data);
          // setSelectedWord(res?.data?.response);
        } else {
          setLoading(false);
          setRephrasedWord((prevData) => [...prevData, { selectedWord: rephrasedWord[i]?.selectedWord, changed: res?.data?.changed, text: res?.data?.response, prompt: prompt ? prompt : 'Can you change the paragraph more clearer?' }]);
        }
        dispatch(toggleLoader(false));
      })
      .catch((err) => {
        dispatch(toggleLoader(false));
        toast.error(err.message);
        setLoading(false);
      });
  };

  const replaceSelectedText = (i) => {
    if (editorRef.current) {
      let editor = editorRef.current;
      let selection = editor.s;

      if (!selection) {
        console.error("Selection not available");
        return;
      }

      selection.insertHTML(rephrasedWord[i]?.text);
      setSchedule({ ...schedule, content: editor.getEditorValue() });
    } else {
      console.error("Editor instance is not available.");
    }
  };

  const handlePrompt = (value) => {
    setPrompt(value);
  };

  const scheduleRef = useRef(schedule?.content);
  useEffect(() => {
    scheduleRef.current = schedule?.content;
  }, [schedule?.content]);

  const selectedRef = useRef(selectedWord);
  useEffect(() => {
    selectedRef.current = selectedWord;
  }, [selectedWord]);

  const selectionTimeout = useRef(null);
  const latestSelectionRef = useRef("");

  const normalizeWhitespace = (text) => {
    return text.replace(/\s+/g, ' ').trim();
  }

  useEffect(() => {
    const handleMouseUp = () => {
      if (selectionTimeout.current) clearTimeout(selectionTimeout.current);

      selectionTimeout.current = setTimeout(() => {
        const selection = window.getSelection().toString().trim();

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = scheduleRef.current;

        const plainText = tempDiv.textContent || tempDiv.innerText || '';

        const normalizedPlainText = normalizeWhitespace(plainText);
        const normalizedSelection = normalizeWhitespace(selection);

        if (selection && normalizedPlainText.includes(normalizedSelection)) {
          setSelectedWord(selection);
          setIsPaste(true);
          if (!rephrasedWord.some((item) => item.selectedWord === selection) && (!rephrasedWord?.length || (rephrasedWord?.length && rephrasedWord[rephrasedWord?.length - 1]?.text))) {
            setRephrasedWord((prevData) => [
              ...prevData,
              { selectedWord: selection, changed: '', text: '', prompt: '' }
            ]);
          } else {
            let data = [...rephrasedWord];
            data[rephrasedWord?.length - 1]['selectedWord'] = selection;
            setRephrasedWord(data);
          }
          latestSelectionRef.current = selection;
        }
      }, 200);
    };

    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
      if (selectionTimeout.current) clearTimeout(selectionTimeout.current);
    };
  }, [rephrasedWord]);

  useEffect(() => {
    const handlePasteShortcut = (e) => {
      if (e.ctrlKey && e.key === 'v' && copyItem?.length) {
        e.preventDefault();

        if (editorRef.current) {
          const editor = editorRef.current;
          const selection = editor.s;

          if (!selection) {
            console.error("Selection not available");
            return;
          }

          selection.insertHTML(copyItem);
          setSchedule({ ...schedule, content: editor.getEditorValue() });
        } else {
          console.error("Editor instance is not available.");
        }
      }
    };

    window.addEventListener('keydown', handlePasteShortcut);

    return () => {
      window.removeEventListener('keydown', handlePasteShortcut);
    };
  }, [copyItem]);

  const isUrl = (value) => {
    try {
      new URL(value);
      return true;
    } catch (_) {
      return false;
    }
  };

  const DrawerList = (
    <Box sx={{ width: 300 }}>
      <DrawerHeader>
        <Box className={styles.post_setting}>Post settings</Box>
        <IconButton onClick={() => setDrawer(false)}>
          <CloseIcon fontSize="small" sx={{ color: "var(--primary)" }} />
        </IconButton>
      </DrawerHeader>
      <Box sx={{ padding: '0px 19px' }}>
        <Box className={styles.featured_img_text}>Featured image<Box className={styles.info}>i</Box></Box>
        <Box className={styles.upload_wrap}>
          {fileId ?
            <Box className={styles.update_container} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
              <Box className={styles.featured_wrap} sx={{ opacity: isHovered && tabvalue !== 4 && '0.1 !important' }}>
                {isUrl(fileId) ? <img src={fileId} className={styles.feature_image} alt="featured" /> :
                  <img src={`${process.env.REACT_APP_ATTACHMENT}?file_id=${fileId}`} className={styles.feature_image} alt="featured" />}
              </Box>
              {isHovered && tabvalue !== 4 && (<Box className={styles.update_wrap}>
                <Box component="label" tabIndex={-1} className={styles.update_circle_icon}>
                  <VisuallyHiddenInput
                    type="file"
                    onChange={(event) => handleUpload(event.target.files[0])}
                    multiple
                    disabled={tabvalue === 4}
                  />
                  <img src={`${process.env.REACT_APP_IMAGE_URL}PostSvg/update-img.svg`} className={styles.update_image} alt='update' />
                </Box>
                <Box className={styles.update_icon} onClick={handleDelete}>
                  <DeleteIcon style={{ color: '#686583' }} fontSize="small" />
                </Box>
              </Box>)}
            </Box> :
            <Button component="label" variant="outlined" tabIndex={-1} className={styles.upload_btn} disabled={tabvalue === 4}>
              +
              <VisuallyHiddenInput
                type="file"
                onChange={(event) => handleUpload(event.target.files[0])}
                multiple
              />
            </Button>}
        </Box>
        <Box className={styles.featured_img_text}>Excerpt<Box className={styles.info}>i</Box></Box>
        <textarea
          value={excerpt}
          className={styles.excerpt_field}
          onChange={(e) => setExcerpt(e.target.value)}
          placeholder="Write a brief excerpt here..."
          rows="3"
          cols="3"
          disabled={tabvalue === 4}
        />
      </Box>
    </Box>
  );

  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (container && selectedRef?.current?.length) {
      container.scrollTop = container.scrollHeight;
    }
  }, [rephrasedWord]);

  const handleCopyItem = (i) => {
    navigator.clipboard.writeText(rephrasedWord[i]?.text);
    setCopyItem(rephrasedWord[i]?.text);
    setCopy(true);
  };

  const handleCloseAIModal = () => {
    setOpenAI(false);
    setRephrasedWord([]);
    setSelectedWord('');
    setCopyItem('');
  };

  const AITools = (
    <Box sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      userSelect: 'none',
      backgroundColor: '#fff',
    }}>
      <Box className={styles.drawer_header_wrap}>
        <Box className={styles.post_setting}>
          <img
            src={process.env.REACT_APP_IMAGE_URL + 'sideBarSvg/Centilio.png'}
            className={styles.centilio_header_icon}
            alt='welcome-img'
          />
        </Box>

        <IconButton sx={{ padding: '5px !important' }} onClick={handleCloseAIModal}>
          <CloseIcon fontSize="medium" sx={{ "&:hover": { color: "#ed4c78" } }} />
        </IconButton>

      </Box>
      <Box ref={containerRef} sx={{ height: 'calc(100vh - 300px)', overflow: rephrasedWord?.length > 1 && 'auto' }}>
        {!rephrasedWord?.length && <Box className={styles.drawer_header_title_wrap}>
          <Box className={styles.sub_titles} sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img
              src={process.env.REACT_APP_IMAGE_URL + 'PostSvg/ai-rephrase.svg'}
              className={styles.centilio_icon}
              alt='welcome-img'
            />
            What can i help you with this section?
          </Box>
        </Box>}
        <Box className={styles.rephrase_container}>
          {rephrasedWord?.map((item, i) => {
            return (
              <Box sx={{ borderBottom: rephrasedWord?.length - 1 !== i && '1px solid #d9d9d9', paddingBottom: i !== 0 && '10px' }} className={styles.rephrase_container} key={i}>
                <Box className={styles.search_titles}>
                  <img
                    src={process.env.REACT_APP_IMAGE_URL + 'PostSvg/voice-id.svg'}
                    className={styles.centilio_icon}
                    alt='welcome-img'
                  />
                  <CommonToolTip title={item?.selectedWord} placement="top" component={<Box className={styles.search_text}>{item?.selectedWord}</Box>} />
                </Box>
                {(item?.prompt === 'Can you change the paragraph more clearer?' || !item?.prompt) && <Box className={styles.improve_wrap} sx={{ cursor: item?.text ? 'auto !important' : 'pointer' }} onClick={() => !item?.text && handleRephrase(null)}>
                  <img
                    src={process.env.REACT_APP_IMAGE_URL + 'PostSvg/improve-pencil-icon.svg'}
                    className={styles.pencil_icon}
                    alt='welcome-img'
                  />
                  <Box className={styles.improve_text}>Can you change the paragraph more clearer?</Box>
                </Box>}
                {item?.prompt !== 'Can you change the paragraph more clearer?' && <Box className={styles.search_titles}>{item?.prompt}</Box>}
                <Box className={styles.rephrasedWord}>{item?.text}</Box>
                {rephrasedWord[i]?.text && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '5px 5px 5px 12px' }}>
                  <Box sx={{ display: 'flex', gap: '10px' }}>
                    <Button
                      onClick={() => replaceSelectedText(i)}
                      className={styles.insert_btn}
                      variant="outlined"
                      size="small"
                      sx={{
                        '&:hover': {
                          backgroundColor: 'var(--primary)',
                          color: '#fff'
                        },
                      }}>
                      Insert
                    </Button>
                    <Button
                      onClick={() => handleRephrase('retry', i)}
                      size="small"
                      className={styles.cancel_btn}
                      variant="outlined"
                      disabled={loading}>
                      Retry
                    </Button>
                  </Box>
                  <Box className={styles.copy_wrap} onClick={() => handleCopyItem(i)} onMouseLeave={() => copy && setCopy(false)}>
                    <CommonToolTip title={copy ? 'Copied' : 'Copy'} placement="bottom" component={
                      <img
                        src={process.env.REACT_APP_IMAGE_URL + 'PostSvg/copy-icon.svg'}
                        className={styles.copy_icon}
                        alt='copy'
                      />
                    } />
                  </Box>
                </Box>}
                {rephrasedWord[i]?.text &&
                  <Box sx={{ backgroundColor: rephrasedWord?.length - 1 === i && '#f5f5f5', marginTop: '7px', paddingBottom: '20px' }}>
                    <Box className={styles.changed}>What's changed?</Box>
                    <Box className={styles.changed_wrap}>
                      <img
                        src={process.env.REACT_APP_IMAGE_URL + 'PostSvg/done.svg'}
                        className={styles.changed_icon}
                        alt='welcome-img'
                      />
                      <CommonToolTip title={item?.changed} placement="top" component={<Box className={styles.changed_title}>{item?.changed}</Box>} />
                    </Box>
                  </Box>}
              </Box>
            )
          })}
        </Box>
      </Box>
      <Box sx={{ backgroundColor: rephrasedWord[0]?.text && '#f5f5f5' }}>
        <TextField
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: '#fff !important',
              "& fieldset": { border: "1px solid var(--border-color)" },
              "&:hover fieldset": { borderColor: "var(--border-color) !important" },
              "&.Mui-focused fieldset": { borderColor: "var(--border-color) !important" },
              boxShadow: '0px 1px 4px 0.5px #7f7f7f4d'
            },
            "& .MuiOutlinedInput-input": { fontSize: "14px" },
            "& .Mui-disabled textarea": {
              WebkitTextFillColor: "black",
              fontSize: "14px",
              fontWeight: "400",
            },
            padding: '10px 15px',
            marginTop: '20px',
          }}
          onChange={(e) => handlePrompt(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && prompt && selectedWord?.length) {
              e.preventDefault();
              handleRephrase(null);
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => handleRephrase(null)} edge="end">
                  {prompt && selectedWord &&
                    <img
                      src={process.env.REACT_APP_IMAGE_URL + 'PostSvg/send-icon.svg'}
                      className={styles.centilio_icon}
                      alt='welcome-img'
                    />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          value={prompt}
          placeholder={!rephrasedWord?.text ? "Tell us what you want us to do?" : ''}
        />
        {rephrasedWord[0]?.text ? <Box sx={{ height: '22px', backgroundColor: '#f5f5f5', }} /> : <></>}
      </Box>
    </Box>
  );

  const handleSignature = () => {
    if (typeof cropperRef.current?.cropper !== 'undefined') {
      let data = cropperRef.current?.cropper.getCroppedCanvas().toDataURL();
      let blob = dataURLtoBlob(data);
      let file = new File([blob], 'featured.jpeg');
      let form = { file: file, org_id: org_info?.default_organizations?.Id, post_id: id }
      const formData = new FormData();

      Object.keys(form).forEach((key) => {
        formData.append(key, form[key]);
      });
      dispatch(toggleLoader(true));
      axios.post(process.env.REACT_APP_FEATURED_IMAGE, formData, { withCredentials: process.env.REACT_APP_CREDENTIALS })
        .then((res) => {
          setFileId(res?.data?.response?.fileId);
          setToggleImage(false);
          dispatch(toggleLoader(false));
        })
        .catch((err) => {
          dispatch(toggleLoader(false));
          const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
          const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
          toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
        });
    }
  };

  const dataURLtoBlob = (dataURL) => {
    let arr = dataURL.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let b64 = atob(arr[1]);
    let n = b64.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = b64.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };


  return (
    <Box className='editor'>
      {/* <TextSelection/> */}
      <Box className={styles.main_div}>
        {tabvalue !== null && tabvalue !== 4 ?
          <Box className={styles.topbar_back_btn} >
            <Box sx={{ paddingTop: '10px' }}>
              <Button variant="outlined" sx={{ textTransform: 'capitalize' }} startIcon={<ArrowBackIcon />} onClick={() => navigate(`/c${org_id}${pathLocal.path}`)}> Back </Button>
            </Box>
            <Box className={styles.topbar_btn}>
              {schedule?.scheduled_time && schedule?.status !== 3 && <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}> {(schedule?.status === 2) ? `Published on ${schedule?.scheduled_time}` : `Scheduled for ${schedule?.scheduled_time}`}</Box>}
              <Button onClick={handleSaveDraft} variant="outlined" disabled={schedule.title.length <= 0 || loading}> Save </Button>
              <Button onClick={() => { org_info.blog_platform.length > 0 ? handleApprove() : toast.error(platform) }} variant="contained" disabled={schedule.title.length <= 0 || loading}>{schedule.date ? tabvalue !== 0 ? 'Save and Publish' : 'Save and Schedule' : 'Save and Publish'} </Button>
              <Box className={styles.settings_container}>
                <img
                  src={process.env.REACT_APP_IMAGE_URL + 'sideBarSvg/Settings.svg'}
                  className={styles.setting_icon}
                  alt='setting-img'
                  onClick={() => setDrawer(true)}
                />
              </Box>
              <Box className={styles.settings_container}>
                <img
                  src={process.env.REACT_APP_IMAGE_URL + 'sideBarSvg/rephrase.svg'}
                  className={styles.setting_icon}
                  alt='setting-img'
                  onClick={() => setOpenAI(true)}
                />
              </Box>
              <Box className={styles.table_user_more_icon}>
                <Tooltip
                  title={getTooltipTitle()}
                  componentsProps={{
                    tooltip: { sx: { bgcolor: "white" } },
                  }}
                  placement="bottom"
                  arrow
                >
                  <MoreHorizIcon
                    className={styles.table_user_more_btn}
                    sx={{
                      border: "1px solid rgba(231, 234, 243, 0.70)",
                      borderRadius: "50%",
                      fill: "#377DFF",
                    }}
                  />
                </Tooltip>
              </Box>
            </Box>
          </Box> : tabvalue !== null && <Box className={styles.topbar_back_btn} >

            <Box sx={{ paddingTop: '10px' }}>
              <Button variant="outlined" sx={{ textTransform: 'capitalize' }} startIcon={<ArrowBackIcon />} onClick={() => navigate(`/c${org_id}${pathLocal.path}`)}> Back </Button>
            </Box>

            <Box className={styles.topbar_btn}>
              {schedule?.scheduled_time && schedule?.status !== 3 && <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}> {(schedule?.status === 2) ? `Published on ${schedule?.scheduled_time}` : `Scheduled for ${schedule?.scheduled_time}`}</Box>}
              <Button onClick={handleApprove} variant="contained" > Approve & Publish </Button>
              <Button onClick={handleRejectandDraft} variant="outlined" color="error"> Reject </Button>
              <Box className={styles.settings_container}>
                <img
                  src={process.env.REACT_APP_IMAGE_URL + 'sideBarSvg/Settings.svg'}
                  className={styles.setting_icon}
                  alt='setting-img'
                  onClick={() => setDrawer(true)}
                />
              </Box>
            </Box>
          </Box>
        }
        <Box
          sx={{
            padding: '0px 60px 0px 60px',
            height: "100%",
            position: 'relative'
          }}
          ref={joditWrapperRef}
        >
          <TextField
            multiline
            sx={{
              backgroundColor: '#fff', position: 'absolute', resize: 'none',
              "& fieldset": { border: 'none' },
              "& .MuiOutlinedInput-input": { fontSize: '24px' },
              "& .Mui-disabled textarea": {
                WebkitTextFillColor: 'black', fontSize: '24px',
                fontWeight: '400'
              },
            }}
            className="custom_textarea"
            onKeyDown={handleKeyDown}
            onChange={(e) => { tabvalue !== 4 && handleChange(e) }}
            value={schedule.title}
            ref={textAreaRef}
            disabled={tabvalue !== 4 ? false : true}
          />
          {/* <button onClick={insertBase64Image}>Insert Base64 Image</button> */}

          <Drawer open={drawer} anchor={'right'} onClose={() => setDrawer(false)}
            sx={{
              "& .MuiBackdrop-root": {
                backgroundColor: "transparent",
              },
              "& .MuiPaper-root": {
                boxShadow: "none",
                border: '1px solid var(--border-color)',
                marginTop: '116px'
              },
            }}>
            {DrawerList}
          </Drawer>
          <Box sx={{ display: 'flex', position: 'relative', height: 'calc(100vh - 120px)' }}>
            <Box sx={{ flexShrink: 0, width: openAI ? 'calc(100% - 400px)' : '100%', transition: 'width 0.5s ease' }}>
              <JoditEditor
                ref={setEditorRef}
                value={schedule?.content}
                config={tabvalue === 4 ? configtwo : config}
                onBlur={handleEditorChange}
              />
            </Box>
            {openAI && (
              <Box
                sx={{
                  flexShrink: 0,
                  width: openAI ? '400px' : '0px',
                  overflow: 'hidden',
                  transition: 'width 0.5s ease',
                  backgroundColor: '#fff',
                  borderLeft: openAI ? '1px solid #d9d9d9' : 'none',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  zIndex: 1,
                }}
              >
                {AITools}
              </Box>
            )}
          </Box>
        </Box>
        <Modal
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '360px',
            borderRadius: '10px',
            padding: '30px',
            overflow: 'hidden',
          }}
          open={toggleImage}
          onClose={() => setToggleImage(false)}
          closeAfterTransition
        >
          <Box style={{
            position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            width: '100%', height: '100%', padding: '30px', overflow: 'hidden', backgroundColor: '#d4e9ff', zIndex: 1
          }}>
            <Cropper
              ref={cropperRef}
              zoomTo={0}
              initialAspectRatio={16 / 9}
              style={{ background: 'transparent', height: '80%', width: "100%" }}
              src={image}
              viewMode={1}
              minCropBoxHeight={10}
              minCropBoxWidth={10}
              background={true}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false}
              guides={true}
            />
            <Box style={{ display: 'flex', gap: '40px', justifyContent: 'space-around', marginTop: '30px' }}>
              <Button variant='contained' className={styles.submit} onClick={handleSignature}>Save</Button>
              <Button variant='contained' onClick={() => setToggleImage(false)} className={styles.cropper_cancel}>
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>
        <ScheduleModal open={open} Schedule={(date) => handleSchedule(date)} setOpen={setOpen} scheduleTime={schedule.date} cancelSchedule={() => handleCancelSchedule()} tabvalue={tabvalue} />
        <ConfirmationModal tabvalue={tabvalue} confirmation={confirmation} setConfirmation={setConfirmation} id={schedule.id} type={type} postOptions={() => postOptions()} />
      </Box>
    </Box>
  )
};

export default Editor;